<ras-page>
	<ras-video-banner *ngIf="video" [video]="video.code" [preview]="video.preview" [position]="video.position" text="We'll take care of it."></ras-video-banner>
	<ras-top-banners></ras-top-banners>

	<p align="center">More reasons to love Rent-A-Store | <a onclick="document.getElementById('reasons-to-love').scrollIntoView({behavior: 'smooth'})">Click here</a></p>

	<main>
		<h1>Car Storage Units and Parking Bays</h1>

		<h2>Choose a car storage facility near you. Find a car storage unit or parking bay and get a quick quote with an OTP</h2>

		<p>Reserve online with no obligation or reservation fees</p>

		<div class="choose-location">
			<div *ngFor="let item of locations | keyvalue">
				<ras-location-thumb [location]="item.value"></ras-location-thumb>
			</div>
		</div>

		<h2>Rent-A-Store Car Storage units and Parking Bays</h2>

		<p>At Rent-A-Store, we offer storage units and parking bays for cars designed with your convenience and your vehicle’s safety in mind.
		Our facilities are secure, well-maintained, and easily accessible, with a range of unit sizes to suit everything from compact cars to
		SUVs.</p>

		<p>There are many great benefits to storing your car in a self-storage parking bay:</p>

		<ol>
			<li>Peace of mind - your stored car is safe 24/7.</li>
			<li>Longevity – by using a professional car storage facility, your car is protected from the elements.</li>
			<li>Access – you can access your vehicle seven days of the week.</li>
			<li>More space – whether you're dealing with limited parking at home, seasonal vehicle storage needs, or require a secure space during extended trips.</li>
		</ol>

		<br />

		<p>Select the car storage facility in Gauteng that is closest to you and get a FREE quote today!</p>

	</main>

	<ras-reasons-to-love></ras-reasons-to-love>

	<ras-box-banner></ras-box-banner>

	<ras-testimonial></ras-testimonial>
</ras-page>
